import AuthenticatedContainer from './AuthenticatedContainer';

export default AuthenticatedContainer;
